const useAppName = () => {
  // On Time Web
  if (window.env.isClockingApp && !window.env.isApp) {
    return 'Comète On Time';
  }
  // App Link (App/Web) ou On Time (App)
  return process.env.REACT_APP_NAME;
};

export default useAppName;
